<template>
    <div class="reset-class-modal">
        <Popup :class-name="showPopup ? 'open' : ''" @closePopup="closePopup" :closeable="true">
            <h4 class="popup-title">
                Reset Class FIC/BIC Data
            </h4>
            <div class="popup-content content">
                <v-form @submit.prevent="handleSubmit" ref="form" class="">
                    <div class="form-content">
                        <p class="mb-2 mt-5">Please select the data you want to reset for the class {{ className }}:</p>
                        <v-select
                            :items="items"
                            v-model="reset"
                            outline
                            item-text="label"
                            item-value="id"
                            single-line
                            :error-messages="errorsMessages.reset"
                        >
                        </v-select>
                        <p class="font-weight-bold mb-3">Please note that after you reset, the data cannot be restored. Would you like to proceed?</p>
                    </div>

                    <div class="buttons vertical">
                        <v-btn type="submit" class="popup-btn" :disabled="saving" :loading="saving">RESET</v-btn>
                    </div>
                </v-form>
            </div>
        </Popup>
    </div>
</template>

<script>
import Popup from '../../../common/Popup.vue';
import ValidationError from '../../../../utils/ValidationError';


export default {
    components: {
        Popup
    },
    props: {
        config:{
            type: Object,
        }
    },
    data() {
        return {
            showPopup: true,
            reset: "fic",
            classId: null,
            className: null,
            saving: false,
            errorsMessages: {},
            items: [
                {
                    "label":"FIC only",
                    "id":"fic",
                },
                {
                    "label":"BIC only",
                    "id":"bic",
                },
                {
                    "label":"BIC and FIC",
                    "id":"both",
                },
            ],
        };
    },
    mounted() {
        this.classId = this.config.classId;
        this.className = this.config.className;
        this.errorsMessages = {};
    },
    methods: {
        async handleSubmit() {
             try {
                this.saving = true;
                this.errorsMessages = {};

                const updated = await this.$store.dispatch("class/resetFicBic", {
                    id: this.classId,
                    reset: this.reset,
                });
                
                this.closePopup();
                
                this.$emit("saved");
                
            } catch (error) {
                 if (error instanceof ValidationError) {
                    this.errorsMessages = error.errors;
                } else {
                    console.error(error);
                    this.closePopup();
                }
            } finally {
                this.saving = false;
            }
        },
        closePopup() {
            this.showPopup = !this.showPopup;
            this.$emit("close");
        }, 
    }
};
</script>

<style lang="scss"></style>
